import { EnumValue } from '../utils';

import { Member } from './member';
import { VpnRegionsList } from './regions';
import { ConnectionStatus } from './status';

export const OS_NAMES = {
    LINUX: 'LINUX',
    MACOS: 'MACOS',
    WINDOWS: 'WINDOWS',
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    ChromeOS: 'CHROMEOS',
    UNKNOWN: 'UNKNOWN',
    EMPTY: 'EMPTY',
} as const;

export type OSNameValue = (typeof OS_NAMES)[keyof typeof OS_NAMES];

export const OS_NAME_MAPPINGS = {
    [OS_NAMES.ANDROID]: 'Android',
    [OS_NAMES.IOS]: 'iOS',
    [OS_NAMES.LINUX]: 'Linux',
    [OS_NAMES.MACOS]: 'macOS',
    [OS_NAMES.WINDOWS]: 'Windows',
    [OS_NAMES.ChromeOS]: 'ChromeOS',
    [OS_NAMES.UNKNOWN]: 'Other OS',
    [OS_NAMES.EMPTY]: 'Empty',
} as const;

/**
 * @deprecated do not use anymore, will be removed in next release
 *
 * TODO: remove in 1.14.6
 */
export const OS_TYPE_FILTER_OPTIONS = Object.entries(OS_NAME_MAPPINGS).reduce(
    (acc, [value, name]) => {
        if (value !== OS_NAMES.ChromeOS) {
            acc.push({ value, name });
        }
        return acc;
    },
    [{ name: 'All', value: '' }],
);

/**
 * @deprecated do not use anymore, will be removed in next release
 *
 * TODO: remove in 1.14.6
 *
 */
export const DEVICE_ID_FILTER_VALUES = {
    ALL: 'all',
    WITH_ID: 'withId',
    WITHOUT_ID: 'noId',
} as const;

/**
 * @deprecated do not use anymore, will be removed in next release
 *
 * TODO: remove in 1.14.6
 */
export const DEVICE_ID_FILTER_OPTIONS = [
    { name: 'All', value: DEVICE_ID_FILTER_VALUES.ALL },
    { name: 'With Client UUID', value: DEVICE_ID_FILTER_VALUES.WITH_ID },
    { name: 'No Client UUID', value: DEVICE_ID_FILTER_VALUES.WITHOUT_ID },
] as const;

export type DevicePlatform = {
    osType?: EnumValue<typeof OS_NAMES>;
    osVersion?: string;
};

export type Device = {
    id: string;
    name: string;
    description?: string;
    applicationId?: string;
    platform?: DevicePlatform;
    ipV4Address: string;
    ipV6Address: string;

    connectedTo?: string;
    connectionStatus: ConnectionStatus;

    vpnRegions: VpnRegionsList;
    group: Member['group'];
    user: Omit<Member, 'group' | 'temporaryPassword' | 'connectionStatus'>;
};

export const DeviceClientVersionIdMap = Object.freeze({
    'openvpn.connect': 'OpenVPN Connect',
    'openvpn.v3': 'OpenVPN3',
});

export function mapDeviceClientVersion(item: { id: string; osType: string; version: string }) {
    const { id, osType, version } = item;

    const friendlyOSName = (OS_NAME_MAPPINGS as any)[osType] ?? osType;
    const friendlyClientName = (DeviceClientVersionIdMap as any)[id] ?? id;
    const friendlyVersion = version.replace(/x.19/i, 'v19_beta');

    const result = `${friendlyOSName}: ${friendlyClientName} ${friendlyVersion}`;

    if (osType === OS_NAMES.ChromeOS) {
        return `${result} (Android)`;
    }
    return result;
}
